import { useQuery } from 'react-query'
import { get } from 'framework/api/http'

export interface SsccXmlListQueryVariables {
  search?: string
  sortBy?: string
  sortDirection?: 'asc' | 'desc'
  take: number
  skip: number
}

export const buildSsccXmlListParams = (vars: SsccXmlListQueryVariables) => {
  const params = new URLSearchParams()
  if (vars.search) params.append('search', vars.search)
  if (vars.sortBy) params.append('sortBy', vars.sortBy)
  if (vars.sortDirection) params.append('sortDirection', vars.sortDirection)
  params.append('take', String(vars.take))
  params.append('skip', String(vars.skip))
  return params
}

/* BDL20-4066: T&W TWD orders whose SSCC XML is on hold (SSCC XML Validation tab) */
export const getSsccXmlValidationList = async (queryData: any) => {
  const vars = queryData.queryKey[1] as SsccXmlListQueryVariables
  const res = await get(
    `/TnW/SsccXml/Validations?${buildSsccXmlListParams(vars).toString()}`,
  )
  return res.data
}

export const useGetSsccXmlValidationList = (
  queryData: SsccXmlListQueryVariables,
) => {
  return useQuery(['ssccXmlValidations', queryData], getSsccXmlValidationList, {
    refetchOnWindowFocus: true,
    keepPreviousData: true,
  })
}

export default useGetSsccXmlValidationList
